import { sendTestMatomoEvent } from "./matomoTest";


// Helper function to format seconds to HH:MM:SS
 function formatSecondsToHMS(seconds) {
    console.log(seconds, "seconds1");
    const hrs = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  }


// For video error logging

export const logVideoErrorEvent = (currentTime, itemDetails, itemData, error) => {
  const platform = "(Tizen)";
  const formattedPlayTime = formatSecondsToHMS(parseInt(currentTime));

  

  const now = new Date();
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  const currentFormattedTime = now
    .toLocaleString("en-GB", options)
    .replace(",", "");

  const videoType = itemDetails?.[0]?.category_title;
  let eventCategory = "Video";

  if (videoType === "TV Channels") {
    eventCategory = "LiveChannel";
  } else if (videoType === "Live") {
    eventCategory = "LiveEvent";
  } else if (videoType === "Movies" || videoType === "Shows") {
    eventCategory = "Video";
  }

  const eventAction = "Error log(Play)";
  const eventName = `${platform}/${itemData?.id}/${itemData?.title}/playtime(${formattedPlayTime})/current time(${currentFormattedTime})/Error log(${error?.message})`;

  sendTestMatomoEvent({
    eventCategory,
    eventAction,
    eventName,
  });
};



 

// For audio error logging

 export const logAudioErrorEvent = (currentTime,itemDetails,itemData,trackData,currentIndex,error) => {
    const platform = "(Tizen)"; // 👉 Dynamically detect if needed (Android/iOS/Web)
    const formattedPlayTime = formatSecondsToHMS(parseInt(currentTime));

    // ✅ Format current date & time
    const now = new Date();
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    const currentFormattedTime = now
      .toLocaleString("en-GB", options)
      .replace(",", "");

    const audioType = itemDetails?.[0]?.category_title;
    let eventCategory = "Audio";
    let contentId = "";
    let contentTitle = "";

    if (audioType === "Radio Channels") {
      eventCategory = "LiveRadio";
      contentId = itemData?.id;
      contentTitle = itemData?.title;
    } else if (audioType === "Audio") {
      eventCategory = "Audio";
      contentId = trackData?.[currentIndex]?.id ?? itemData?.id;
      contentTitle = `${itemData?.title}/${trackData?.[currentIndex]?.title}`;
    }

    const eventAction = "Error log(Play)";
    const errorMessage = error?.message || error?.toString() || "Unknown error";

    const eventName = `${platform}/${contentId}/${contentTitle}/playtime(${formattedPlayTime})/current time(${currentFormattedTime})/Error log(${errorMessage})`;

    sendTestMatomoEvent({
      eventCategory,
      eventAction,
      eventName,
    });

    console.log("🎧 Audio Error Event Sent:", { eventCategory, eventAction, eventName });
  };
